var _rect, _path, _path2, _path3, _ellipse, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHauntedThumbnailContrast = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 102,
    viewBox: "0 0 104 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-fill-light",
    x: 102.795,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    transform: "rotate(90 102.795 0.5)",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-dark",
    d: "M24.8058 62C31.878 62.8986 34.6295 61.4829 38.3058 60.5C43.1267 45.5768 37.9657 36.9372 34.8058 35.5C31.6459 34.0627 26.9515 36.1369 25.7665 38.8863C24.8185 41.0859 12.9493 41.3338 2.21451 41.4198C2.21451 59.9198 2.21451 56.4198 2.21451 56.4198L13.3058 56.4198C13.6393 57.0836 17.7336 61.1013 24.8058 62Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2643 35.6778L102.214 9.9198C102.214 9.9198 102.214 31.4198 102.214 47.9333C102.214 64.4468 102.214 85.9198 102.214 85.9198L62.2643 60.7698C62.2643 60.7698 58.4144 55.986 58.4144 47.9333C58.4144 39.8806 62.2643 35.6778 62.2643 35.6778Z",
    fill: "url(#paint0_linear_357_9470)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-dark thumbnail-stroke-light",
    d: "M47.4116 40.926H47.6154L47.7611 40.7836C48.196 40.3587 48.7121 39.9949 49.2755 39.6968L57.302 35.4505L61.8269 33.2757C62.39 33.0743 62.9702 32.9695 63.5631 32.9695C65.8626 32.9695 68.0356 34.5629 69.6612 37.3362C71.2799 40.0975 72.2972 43.9451 72.2972 48.222C72.2972 52.499 71.2799 56.3466 69.6612 59.1079C68.0356 61.8811 65.8626 63.4746 63.5631 63.4746C62.971 63.4746 62.3915 63.37 61.8291 63.1691L56.6935 60.6413L56.6879 60.6386L49.3534 56.9152C48.703 56.5851 48.1134 56.1679 47.6339 55.671L47.4865 55.5182H47.2741L25.3576 55.5181L20.054 54.5984C16.968 54.0632 14.7145 51.3853 14.7145 48.2532C14.7145 45.1483 16.9299 42.4855 19.983 41.9208L25.3609 40.926H47.4116Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "thumbnail-fill-light",
    cx: 64.4557,
    cy: 48.0296,
    rx: 6.54485,
    ry: 13.5709,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-light",
    d: "M24.9547 41.6355C25.0174 41.4858 25.1639 41.3884 25.3262 41.3884H44.7812C45.0545 41.3884 45.2485 41.6548 45.1646 41.915L44.7829 43.0984C44.7292 43.2648 44.5743 43.3775 44.3995 43.3775H24.8299C24.5421 43.3775 24.3471 43.0844 24.4584 42.8189L24.9547 41.6355Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-fill-light thumbnail-stroke-dark",
    cx: 38.2442,
    cy: 42.5114,
    r: 2.26454,
    fill: "white",
    stroke: "#1E1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-dark",
    d: "M58.7118 52.7592C58.7373 52.9802 58.9377 53.1404 59.1559 53.0966C60.2013 52.8866 61.1522 52.3359 61.8561 51.525C62.6484 50.6123 63.0704 49.4361 63.039 48.2279C63.0076 47.0197 62.5251 45.867 61.6864 44.9967C60.9413 44.2235 59.9631 43.723 58.9082 43.5675C58.688 43.5351 58.4962 43.7055 58.4822 43.9275L58.2482 47.6359C58.218 48.1134 58.2305 48.5927 58.2854 49.068L58.7118 52.7592Z",
    fill: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-dark",
    d: "M43.3432 50.0664C45.2833 52.2797 47.7145 55.6436 45.7145 57.1826C43.6868 58.7428 42.2254 58.1023 40.6896 56.2928C41.9142 58.4143 42.3107 59.807 40.2145 60.9198C38.6115 61.7708 37.3142 61.5339 36.2157 60.6663C36.609 61.8978 36.248 62.9114 34.2145 63.4198C32.2807 63.9033 30.9802 63.4303 29.9595 62.4842C29.8033 62.8447 29.285 63.1522 28.2145 63.4198C26.2145 63.9198 24.4925 62.827 22.8177 59.9785C21.635 57.5594 20.1834 51.7143 21.7145 50.9198C23.1564 50.1716 23.819 50.5131 24.3312 51.5271C24.0066 50.1034 24.0258 48.8607 24.6947 48.0942C25.7862 46.8435 27.7193 47.9194 29.7534 50.4095C28.6364 48.1706 28.0183 46.2132 28.9673 45.5815C30.9659 44.251 33.8174 46.7739 35.9482 49.2762C35.0329 47.6336 34.3285 45.8858 34.8522 44.9965C35.9311 43.1642 42.9356 49.5873 43.3432 50.0664Z",
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-stroke-light",
    d: "M27.2145 58.4198C28.9241 61.3277 30.2145 64.4198 34.2145 63.4198C38.6224 62.3179 35.172 58.8417 33.2146 55.9198C30.2145 49.9198 26.4125 46.126 24.6947 48.0942C22.977 50.0623 25.5433 55.1699 27.2145 58.4198ZM27.2145 58.4198C28.809 60.9961 32.0423 62.4629 28.2145 63.4198C26.2145 63.9198 24.4925 62.827 22.8177 59.9785C21.635 57.5594 20.1834 51.7143 21.7145 50.9198C25.1346 49.1451 24.1704 53.5015 27.2145 58.4198ZM43.3432 50.0664C45.2833 52.2797 47.7145 55.6436 45.7145 57.1826C42.7145 59.491 40.954 56.9819 38.3582 52.9972C37.9073 52.305 33.7732 46.8287 34.8522 44.9965C35.9311 43.1642 42.9356 49.5873 43.3432 50.0664ZM38.7145 52.9972C41.0709 57.1226 43.2413 59.3129 40.2145 60.9198C37.1876 62.5267 35.2508 60.2545 33.6843 57.1826C31.6607 53.7406 27.0223 46.8763 28.9673 45.5815C32.2145 43.4198 37.7129 51.4299 38.7145 52.9972Z",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-light",
    d: "M23.7146 61.4199C25.869 64.3519 27.4949 63.7981 28.2146 63.4199C23.0063 60.2378 22.8019 54.6767 21.7146 50.9199C21.7146 50.9199 20.2146 51.1337 20.7146 54.4199C20.9428 55.9199 21.0215 57.7548 23.7146 61.4199Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-light",
    d: "M38.6625 53.6912C41.5398 58.0912 43.2145 58.9198 45.2145 57.4198C41.9207 54.7813 37.0427 48.0546 35.0154 44.771C33.7146 45.9198 34.9643 48.0359 38.6625 53.6912Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-dark thumbnail-stroke-light",
    d: "M38.3058 41.5C41.3058 41.5 43.7185 39.2639 41.3057 37.5C38.8928 35.7361 31.3059 32.5 27.8058 32.5C22.2832 32.5 18.8058 33 9.74086 37.9296C7.77436 39.2064 6.30571 38.546 2.2144 37.9056L2.21441 44L11.8058 44C14.3058 45.5 18.8058 45.6423 20.8058 45.5C24.8058 45.2155 29.3058 40.5 29.3058 40.5C31.8971 40.5705 31.3383 40.5 33.8058 40.5C35.8058 40.5 35.3058 41.5 38.3058 41.5Z",
    fill: "#1E1E1E",
    stroke: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-light",
    d: "M32.7144 56.9199C36.7145 63.9199 40.2145 60.9199 40.2145 60.9199C40.2145 60.9199 31.5072 51.0515 28.7145 45.9199C27.8496 46.9667 28.3386 49.2622 32.7144 56.9199Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-light",
    d: "M27.7146 59.4198C30.47 64.6558 32.04 63.8413 34.2145 63.4198C30.4674 59.0608 26.0251 53.7316 24.4437 48.2951C23.4994 50.8091 24.2703 52.875 27.7146 59.4198Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_357_9470",
    x1: 59.7145,
    y1: 47.9198,
    x2: 100.714,
    y2: 47.9198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "thumbnail-flashlight-light",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    className: "thumbnail-flashlight-light",
    offset: 1,
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHauntedThumbnailContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HauntedThumbnail-contrast.113da1397bc03807a4e4b46fc0c8b36e.svg";